import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/LanguageContext";
import "./BackButton.css";

// Botón flotante con flecha para volver al inicio ("/") desde las páginas de
// carta/menú (carta, sugerencias, postres, bodega, sake, whisky).
export default function BackButton() {
  const { t } = useI18n();

  return (
    <Link to="/#card" className="back-button" aria-label={t("nav.back")} title={t("nav.back")}>
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          d="M15 4 7 12l8 8"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  );
}
